import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { VENDING_PACKAGE_VOLUME_BY_USER_LIST_CHART_DEFINITION } from './vending-package-volume-by-user-list-chart.definition';
import { VENDING_PACKAGE_VOLUME_BY_USER_LIST_CHART_MOCK_DATA } from './vending-package-volume-by-user-list-chart.mock';

export const VendingPackageVolumeByUserListChart = (props: ListChartProps) => <ListChart {...props} />;

VendingPackageVolumeByUserListChart.definition = VENDING_PACKAGE_VOLUME_BY_USER_LIST_CHART_DEFINITION;
VendingPackageVolumeByUserListChart.mockData = VENDING_PACKAGE_VOLUME_BY_USER_LIST_CHART_MOCK_DATA;
